var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it)) throw TypeError(String(it) + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/an-object.js
// module id = 0
// module chunks = 0